'use strict';

import Util from './util.js';
import KNB from '@dp/knb';
import Toast from '@dp/wepp-module-toast';

let cx = '';
function shareSuccess () {
  return Util.reqwest('/mobile/event/arro/shareget', {
        type: 'activity',
        cx: cx
    }).then((r) => {
        if (r.code == 200 && r.msg) {
            // let addScore = r.msg.score
            // parseInt(addScore) && Toast(`分享成功，又增加了${addScore}霸气值`)
            return Promise.resolve(r);
        } else {
            return Promise.reject(`Unkown: ${r.code}`);
        }
    }).catch((e) => {
        return Promise.reject(`Exception: ${e}`);
    })
}
export const shareSuccHandler = () => {
    if (Util.isApp()) {
        console.log('=====isapp=====')
        KNB.getFingerprint({
            success: function (ret) {
                cx = ret.fingerprint;
                shareSuccess();
            },
            fail: function () {
                Toast('出错了')
            }
        })
    } else {
        console.log('=====not app====')
        shareSuccess();
    }
    
}


// WEBPACK FOOTER //
// ./src/common/js/share_cb.js